import React from 'react'

export default function ContactForm({ location, phone, email, name, id }) {
  return (
    <div className="contact-container">
      {/*<!-- Contact Form -->*/}
      <form id={id} name={name} method="POST" data-netlify="true">
        <div className="row">
          {/*<!-- Name Field -->*/}
          <div className="input-field col s12">
            <i className="fa fa-user-o prefix" aria-hidden="true" />
            <input
              id="contact-name"
              type="text"
              className="validate"
              name="first_name"
              required
            />
            <label htmlFor="contact-name">Name*</label>
          </div>

          {/*<!-- Email Field -->*/}
          <div className="input-field col s12 m-t-1">
            <i className="fa fa-paper-plane-o prefix" aria-hidden="true" />
            <input
              id="contact-email"
              type="email"
              className="validate"
              name="email"
              required
            />
            <label data-error="Invalid Email" htmlFor="contact-email">
              Email*
            </label>
          </div>

          {/*<!-- Message Field -->*/}
          <div className="input-field col s12 m-t-1">
            <i className="fa fa-envelope-o prefix" aria-hidden="true" />
            <textarea
              id="contact-message"
              className="materialize-textarea validate"
              minLength="20"
              name="message"
              required
            />
            <label
              htmlFor="contact-message"
              data-error="Minimum Length is 20 Characters"
            >
              Message*
            </label>
          </div>

          {/*<!-- Form Alert Message -->*/}
          <div className="col s12 alert-message" id="contact-alert-message" />

          {/*<!-- Submit Button -->*/}
          <div className="col s12">
            <button
              id="contact-submit"
              className="gradient-color waves-effect waves-light"
              type="submit"
            >
              Send Message
            </button>
          </div>

          {/*<!-- ! Anti-spam field ! Invisible for users, it will trick most bots to fill it and prevent the email from being sent to you -->*/}
          <div className="input-field col s12 hidden">
            <input
              type="text"
              id="contact-check-spam"
              placeholder="Leave field empty"
              name="check-spam"
            />
          </div>
        </div>
      </form>

      <div className="address">
        {/*<!-- Your Address -->*/}
        <p className="p-b-1">
          <i className="address-icon fa fa-map-marker" />
          <span>{location}</span>
        </p>

        {/*<!-- Your Email -->*/}
        <p className="p-b-1">
          <i className="address-icon fa fa-paper-plane" aria-hidden="true" />
          <a href={`mailto:${email}`}>{email}</a>
        </p>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ContactForm.js